import { HOSTS, plural, whenLabel } from '../format';
import { useApp } from '../store';
import { btn, mono, panel } from '../ui';

const GRID = '1.6fr .7fr 90px 90px 70px 1.4fr';

export function Net() {
  const app = useApp();

  const measured = app.hosts.filter(h => h.state !== 'offline' && h.down > 0);
  const medianDown = median(measured.map(h => h.down));
  const netLimit = app.thresholds.find(t => t.key === 'net')?.limit ?? 0;
  const below = measured.filter(h => h.down < netLimit).length;
  const lastSpeedJob = app.jobs.find(j => j.kind === 'speed');

  const kpis = [
    { label: 'Медиана загрузки', value: medianDown ? `${medianDown} Мбит/с` : '—', color: 'var(--ink)' },
    { label: 'Хостов ниже нормы', value: String(below), color: below ? 'var(--warn)' : 'var(--ok)' },
    {
      label: 'Последняя проверка',
      value: lastSpeedJob ? whenLabel(lastSpeedJob.createdAt).replace('сегодня ', '') : '—',
      color: 'var(--ink)'
    }
  ];

  // Медленные — вверх: именно их и ищут на этом экране.
  const rows = [...app.shown]
    .filter(h => h.state !== 'offline')
    .sort((a, b) => a.down - b.down)
    .slice(0, 24);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ display: 'flex', alignItems: 'stretch', flexWrap: 'wrap', gap: 14 }}>
        {kpis.map(k => (
          <div
            key={k.label}
            style={{
              flex: '1 1 190px',
              ...panel,
              padding: '16px 18px',
              display: 'flex',
              flexDirection: 'column',
              gap: 6
            }}
          >
            <span style={{ fontSize: 11.5, color: 'var(--ink3)' }}>{k.label}</span>
            <span
              style={{
                fontFamily: 'var(--fh)',
                fontSize: 27,
                fontWeight: 700,
                letterSpacing: '-0.02em',
                lineHeight: 1.05,
                color: k.color
              }}
            >
              {k.value}
            </span>
          </div>
        ))}

        <button
          className="bright"
          onClick={() => void app.runSpeed()}
          style={{
            ...btn,
            flex: 'none',
            alignSelf: 'stretch',
            padding: '0 22px',
            display: 'flex',
            alignItems: 'center',
            borderRadius: 'var(--r)',
            background: 'var(--acc)',
            color: 'var(--accInk)',
            fontSize: 13.5,
            fontWeight: 600,
            whiteSpace: 'nowrap'
          }}
        >
          Speedtest на {plural(app.selCount || Math.min(16, measured.length), HOSTS)}
        </button>
      </div>

      <section style={{ ...panel, padding: '8px 20px 16px' }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: GRID,
            gap: 14,
            padding: '12px 0',
            fontSize: 11,
            color: 'var(--ink3)',
            borderBottom: '1px solid var(--line)'
          }}
        >
          <span>Хост</span>
          <span>Локация</span>
          <span style={{ textAlign: 'right' }}>Загрузка</span>
          <span style={{ textAlign: 'right' }}>Отдача</span>
          <span style={{ textAlign: 'right' }}>Ping</span>
          <span>Профиль канала</span>
        </div>

        {rows.map(h => {
          const downColor = h.down < netLimit ? 'var(--bad)' : 'var(--ok)';
          return (
            <div
              key={h.id}
              style={{
                display: 'grid',
                gridTemplateColumns: GRID,
                gap: 14,
                padding: '10px 0',
                borderBottom: '1px solid var(--line)',
                alignItems: 'center',
                fontSize: 12
              }}
            >
              <span style={mono}>{h.name}</span>
              <span style={{ color: 'var(--ink3)' }}>{h.loc}</span>
              <span style={{ textAlign: 'right', ...mono, color: downColor }}>{h.down} Мбит</span>
              <span style={{ textAlign: 'right', ...mono, color: 'var(--ink2)' }}>{h.up} Мбит</span>
              <span style={{ textAlign: 'right', ...mono, color: h.ping > 35 ? 'var(--warn)' : 'var(--ink2)' }}>
                {h.ping} мс
              </span>
              <span style={{ display: 'block', height: 6, borderRadius: 99, background: 'var(--track)' }}>
                <span
                  style={{
                    display: 'block',
                    height: 6,
                    borderRadius: 99,
                    background: downColor,
                    width: Math.min(100, Math.round((h.down / 1000) * 100)) + '%'
                  }}
                />
              </span>
            </div>
          );
        })}

        {!rows.length && (
          <div style={{ padding: '30px 0', fontSize: 12.5, color: 'var(--ink3)' }}>
            Данных по каналу пока нет — запустите speedtest.
          </div>
        )}
      </section>
    </div>
  );
}

function median(values: number[]): number {
  if (!values.length) return 0;
  const sorted = [...values].sort((a, b) => a - b);
  return sorted[Math.floor(sorted.length / 2)];
}
